(() => {
  function initialize(root = document) {
    root.querySelectorAll('.menu-toggle:not([data-ready])').forEach(button => {
      button.dataset.ready = 'true';
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      if (!nav) return;
      const setOpen = open => {
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        nav.hidden = !open;
      };
      button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
      nav.addEventListener('click', event => { if (event.target.closest('a')) setOpen(false); });
      nav.addEventListener('keydown', event => { if (event.key === 'Escape') { setOpen(false); button.focus(); } });
      button.addEventListener('keydown', event => { if (event.key === 'Escape') setOpen(false); });
      matchMedia('(min-width:991px)').addEventListener('change', event => { if (event.matches) setOpen(false); });
    });
    root.querySelectorAll('.books-menu:not([data-ready])').forEach(menu => {
      menu.dataset.ready = 'true';
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
      menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) menu.open = false; });
    });
    root.querySelectorAll('[data-variant-select]:not([data-ready])').forEach(select => {
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        // Reload the selected variant through Shopify so quantity rules, app blocks,
        // availability and prices all use the same server-authoritative state.
        const url = new URL(location.href);
        url.searchParams.set('variant', select.value);
        url.hash = 'purchase';
        location.assign(url.href);
      });
    });
    root.querySelectorAll('[data-product-form]:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const price = form.querySelector('[data-price-display]') || form.closest('.book-purchase-panel')?.querySelector('[data-price-display]');
      const addButton = form.querySelector('[data-add-button]');
      const buyButton = form.querySelector('[data-buy-now]');
      form.querySelectorAll('[data-variant-radio]').forEach(radio => {
        radio.addEventListener('change', () => {
          if (price) price.textContent = radio.dataset.price;
          const available = radio.dataset.available === 'true';
          if (addButton) {
            addButton.disabled = !available;
            addButton.textContent = available ? 'Add to cart' : 'Sold out';
          }
          if (buyButton) buyButton.disabled = !available;
          const url = new URL(location.href);
          url.searchParams.set('variant', radio.value);
          history.replaceState({}, '', url);
        });
      });
      form.querySelectorAll('[data-quantity-change]').forEach(button => {
        button.addEventListener('click', () => {
          const input = form.querySelector('input[name="quantity"]');
          if (!input) return;
          const step = Number(input.step) || 1;
          const min = Number(input.min) || 1;
          const max = input.max ? Number(input.max) : Infinity;
          input.value = Math.min(max, Math.max(min, Number(input.value || min) + Number(button.dataset.quantityChange) * step));
        });
      });
      if (buyButton) buyButton.addEventListener('click', async () => {
        const originalLabel = buyButton.textContent;
        buyButton.disabled = true;
        buyButton.textContent = 'Preparing checkout…';
        try {
          const response = await fetch(`${buyButton.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('Unable to add this format to checkout.');
          location.assign('/checkout');
        } catch (error) {
          buyButton.disabled = false;
          buyButton.textContent = originalLabel;
          window.alert(error.message);
        }
      });
    });
    root.querySelectorAll('video:not([data-ready])').forEach(video => {
      video.dataset.ready = 'true';
      video.addEventListener('play', () => document.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); }));
    });
  }
  document.addEventListener('click', event => document.querySelectorAll('.books-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }));
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

(() => {
  const safeStorage = {
    get(key) {
      try { return localStorage.getItem(key); } catch (_) { return null; }
    },
    set(key, value) {
      try { localStorage.setItem(key, value); } catch (_) { /* Private browsing can disable storage. */ }
    }
  };

  function workshopAttribution() {
    const params = new URLSearchParams(window.location.search);
    const attribution = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ref'].forEach(key => {
      const value = params.get(key);
      if (value) attribution[key] = value.slice(0, 200);
    });
    return attribution;
  }

  function trackWorkshopEvent(name, workshop, extra = {}) {
    const detail = {
      event: name,
      workshop: workshop.dataset.workshopKey,
      path: window.location.pathname,
      ...workshopAttribution(),
      ...extra
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('dayone:workshop-event', { detail }));
  }

  function initializeWorkshop(root = document) {
    root.querySelectorAll('[data-workshop-root]:not([data-workshop-ready])').forEach(workshop => {
      workshop.dataset.workshopReady = 'true';
      const workshopKey = workshop.dataset.workshopKey;
      const params = new URLSearchParams(window.location.search);
      const moduleNumber = Number(params.get('module'));
      const requestedModule = moduleNumber >= 1 && moduleNumber <= 5;
      const requestedCompletion = params.get('complete') === '1';
      const hasAccess = workshop.dataset.workshopAccess === 'true';
      const showCompletion = hasAccess && requestedCompletion;
      const landing = workshop.querySelector('[data-workshop-landing]');
      const completion = workshop.querySelector('[data-workshop-completion]');
      const modules = [...workshop.querySelectorAll('[data-workshop-module]')];
      const validModule = hasAccess && requestedModule;

      if (landing) landing.hidden = validModule || showCompletion;
      if (completion) completion.hidden = !showCompletion;
      modules.forEach(module => {
        module.hidden = Number(module.dataset.workshopModule) !== moduleNumber || showCompletion;
      });

      if (!hasAccess && (requestedModule || requestedCompletion)) {
        const accessMessage = workshop.querySelector('[data-workshop-access-message]');
        if (accessMessage) accessMessage.hidden = false;
        requestAnimationFrame(() => workshop.querySelector('#workshop-register')?.scrollIntoView({ block: 'start' }));
      }

      trackWorkshopEvent('workshop_page_viewed', workshop, {
        view: validModule ? 'module' : showCompletion ? 'completion' : 'landing',
        module: validModule ? moduleNumber : undefined,
        member_access: hasAccess
      });

      workshop.querySelector('.workshop-hero-copy a[href="#workshop-register"]')?.addEventListener('click', () => {
        trackWorkshopEvent('workshop_start_clicked', workshop);
      });
      if (workshop.querySelector('[data-workshop-registration-success]')) {
        const signupEvent = {
          'day-one': 'day_one_reset_signup',
          'long-game': 'long_game_workshop_signup',
          invisible: 'invisible_advantage_signup'
        }[workshopKey] || 'workshop_registration_completed';
        trackWorkshopEvent(signupEvent, workshop);
      }
      workshop.querySelectorAll('[data-workshop-book-click]').forEach(link => link.addEventListener('click', () => {
        trackWorkshopEvent('workshop_book_click', workshop, { destination: link.href });
      }));
      workshop.querySelectorAll('[data-workshop-workbook-download]').forEach(link => link.addEventListener('click', () => {
        trackWorkshopEvent('workbook_download', workshop, { module: validModule ? moduleNumber : undefined });
      }));

      const progressKey = `day-one-workshop-progress-${workshopKey}`;
      let completed = [];
      try { completed = JSON.parse(safeStorage.get(progressKey) || '[]'); } catch (_) { completed = []; }
      const updateProgress = () => {
        workshop.querySelectorAll('[data-workshop-nav-item]').forEach(item => {
          const itemNumber = Number(item.dataset.workshopNavItem);
          item.classList.toggle('is-complete', completed.includes(itemNumber));
          const status = item.querySelector('[data-workshop-nav-status]');
          if (status && itemNumber !== moduleNumber) status.textContent = completed.includes(itemNumber) ? 'Completed' : '';
        });
        workshop.querySelectorAll('[data-workshop-progress-dot]').forEach(dot => {
          dot.classList.toggle('is-complete', completed.includes(Number(dot.dataset.workshopProgressDot)));
        });
      };
      updateProgress();

      workshop.querySelectorAll('[data-workshop-answer]').forEach(field => {
        const key = `day-one-workshop-answer-${field.dataset.workshopAnswer}`;
        const saved = safeStorage.get(key);
        if (saved !== null && field.value === '') field.value = saved;
        field.addEventListener('input', () => safeStorage.set(key, field.value));
      });

      workshop.querySelectorAll('[data-complete-module]').forEach(link => {
        link.addEventListener('click', () => {
          const completedModule = Number(link.dataset.completeModule);
          if (!completed.includes(completedModule)) completed.push(completedModule);
          completed.sort((a, b) => a - b);
          safeStorage.set(progressKey, JSON.stringify(completed));
          updateProgress();
        });
      });

      const download = workshop.querySelector('[data-download-workshop]');
      if (download) download.addEventListener('click', () => {
        trackWorkshopEvent('workshop_answers_downloaded', workshop);
        const lines = [`${workshopKey.replaceAll('-', ' ').toUpperCase()} — MY WORKSHOP ANSWERS`, ''];
        workshop.querySelectorAll('[data-workshop-answer]').forEach(field => {
          const label = workshop.querySelector(`label[for="${field.id}"]`);
          const answer = safeStorage.get(`day-one-workshop-answer-${field.dataset.workshopAnswer}`) || '';
          if (answer.trim()) lines.push(label?.textContent?.trim() || field.dataset.workshopAnswer, answer.trim(), '');
        });
        const blob = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `${workshopKey}-workshop-answers.txt`;
        anchor.click();
        URL.revokeObjectURL(url);
      });

      if (validModule || showCompletion) window.scrollTo({ top: 0, behavior: 'instant' });
    });
  }

  initializeWorkshop();
  document.addEventListener('shopify:section:load', event => initializeWorkshop(event.target));
})();

(() => {
  function journalAttribution() {
    const params = new URLSearchParams(window.location.search);
    const attribution = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ref'].forEach(key => {
      const value = params.get(key);
      if (value) attribution[key] = value.slice(0, 200);
    });
    return attribution;
  }

  function pushJournalEvent(event, extra = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, path: window.location.pathname, ...journalAttribution(), ...extra });
  }

  function initializeJournal(root = document) {
    root.querySelectorAll('[data-journal-workshop-link]:not([data-ready])').forEach(link => {
      link.dataset.ready = 'true';
      link.addEventListener('click', () => pushJournalEvent('journal_workshop_clicked', { destination: link.href }));
    });
    root.querySelectorAll('[data-journal-member-success]:not([data-ready])').forEach(success => {
      success.dataset.ready = 'true';
      pushJournalEvent('day_one_journal_signup');
    });
  }

  initializeJournal();
  document.addEventListener('shopify:section:load', event => initializeJournal(event.target));
})();
